let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lijQ3")).then(() => parcelRequire('jQfjq'));